import { render, staticRenderFns } from "./GerenciadorRequests.vue?vue&type=template&id=1862f633&"
import script from "./GerenciadorRequests.vue?vue&type=script&lang=js&"
export * from "./GerenciadorRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1862f633')) {
      api.createRecord('1862f633', component.options)
    } else {
      api.reload('1862f633', component.options)
    }
    module.hot.accept("./GerenciadorRequests.vue?vue&type=template&id=1862f633&", function () {
      api.rerender('1862f633', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/recursos/GerenciadorRequests.vue"
export default component.exports